"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesIconButton = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "iconName", type: "string", description: "Is required. Name of the icon that will be rendered." }),
    React.createElement(common_1.Property, { name: "iconColor", type: "string", description: "Sets the background color." }))); };
exports.PropertiesIconButton.displayName = 'PropertiesIconButton';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconButtonPage/PropertiesIconButton.tsx
// module id = 681
// module chunks = 0